<template>
  <Box>
    <template #handle>
      <Btn @click="() => open = true" type="blue"> 手动上传</Btn>
    </template>
    <template #content>

      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="加工年度" prop="workYear">
                    <el-date-picker v-model="queryParams.workYear" type="year" placeholder="选择年" format="yyyy"
                      value-format="yyyy" size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="生产线" prop="workLine">
                    <el-select v-model="queryParams.workLine" size="small" clearable>
                      <el-option v-for="item in scxs" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上传状态" prop="uploadStatus">
                    <el-select v-model="queryParams.uploadStatus" size="small" clearable>
                      <el-option key="4" label="-请选择-" value="" />
                      <el-option key="0" label="未上传" value="0" />
                      <el-option key="1" label="上传成功" value="1" />
                      <el-option key="2" label="上传报错" value="2" />
                      <el-option key="3" label="网络访问失败" value="3" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="24"></el-col> -->
                <el-col :span="8">
                  <el-form-item label="上传时间" prop="uploadDate">
                    <el-date-picker 
                      v-model="queryParams.uploadDate" 
                      type="daterange" 
                      range-separator="至"
                      start-placeholder="开始日期" 
                      end-placeholder="结束日期" 
                      format="yyyy-MM-dd" 
                      value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="条码" prop="barCodeLike">
                    <el-input size="small" v-model="queryParams.barCodeLike"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="resetQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>

        <div class="content">
          <Table 
            :datas="tableData" 
            :heads="tableHead" 
            :selection="true" 
            @change="changeTableSelected" 
            ref="tableData"
          >
            <template #handle="data">
              <div class="table_cell">
                <!-- 序号 -->
                <div v-if="data.head.handle == 'index'">
                  {{ (pageData.pageNum - 1) * 10 + data.index }}
                </div>
                <!-- 操作 -->
                <div v-if="data.head.handle == 'btns'">
                  <Btn
                    type="text"
                    v-show="checkReloadManualUpload(data.data)"
                    @click="handleReloadManualUpload(data.data)"
                  >重新上传</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination 
            class="page" 
            background 
            layout="total, sizes, prev, pager, next" 
            :total="pageData.total"
            :current-page.sync="pageData.pageNum" 
            :page-size.sync="pageData.pageSize"
            @current-change="getList"
            @size-change="getList"
          >
          </el-pagination>
        </div>
      </div>

      <Drawer :open="open" @changeOpen="changeOpen" width='520px' :title="drawerTitle">

        <template #content>
            <el-form  :rules="rules">
              <el-form-item label="附件：" prop="uploadFile">
                <el-upload
                  class="manualUpload"
                  ref="manualUpload"
                  action=''
                  :file-list="fileList"
                  :auto-upload="false"
                  :on-change="manualUploadChange" 
                  :before-remove="manualUploadBeforeRemove" 
                  :on-remove="manualUploadRemove"
                  :http-request="upLoadMethod"
                  name="file"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" class="el-upload__tip">大小不超过1MB</div>
                </el-upload>
              </el-form-item>
              <el-progress 
                v-if="progress"
                :percentage="progressPercent"
                :status="importStatus"
              ></el-progress>
              
            </el-form>
        </template>
        <template #footer>
          <Btn type="blue" @click="submitUpload" :disabled='manualUploadBtnDisabled'>上传</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import {
  scxs
} from "@/utils/status";
import {
  manualUploadData,
  queryManualUploadList,
  reloadManualUploadReq
} from "@/api/BusinessDataUploadRemedy";
import permMixin from "@/mixins/perm";
import drawerMixins from "@/components/drawer/drawer";
import  { formatDate } from '@/utils/index'
import { tableHead } from './tableHead'
export default {
  mixins: [drawerMixins, permMixin],
  data() {
    return {
      pageData: {
        pageNum: 1,
        pageSize: 10,
        total: 0, 
      },
      queryParams: {
        workYear: '',
        workLine: '',
        uploadStatus: '', 
        uploadDate: '',
        barCodeLike: '', //条码
      },
      // 生产线
      scxs: JSON.parse(JSON.stringify(scxs)),
      tableData: [],
      tableHead: tableHead,
      drawerTitle: '手动上传',
      open: false,
      fileList: [],
      fileData: "", //FormData上传文件
      manualUploadBtnDisabled: true,
      manualUploadParams: {},
      // 进度条
      progress:false,
      progressPercent: 0,
      importStatus: null,
      rules: {
        uploadFile: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ]
      }

    }
  },
  methods: {
    checkReloadManualUpload(rowData) {
      let curDate = formatDate(new Date()).substring(0,10)
      rowData.uploadTime = rowData.uploadTime || ''
      let checkDateFlag = curDate == rowData.uploadTime.substring(0,10)
      if(rowData.uploadStatus == 0 || (rowData.uploadStatus == 3 && checkDateFlag) ) {
        return true
      }
      return  false
    },
    changeTableSelected() {

    },
    resetQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    query() {
      this.pageData.pageNum = 1;
      this.getList();
    },
    getList() {
      let params = Object.assign({}, this.queryParams, this.pageData)
      params = JSON.parse(JSON.stringify(params))
      params.uploadStartDate = params.uploadDate[0] || ''
      params.uploadEndDate = params.uploadDate[1] || ''
      delete params.uploadDate
      queryManualUploadList(params)
      .then(res => {
        this.pageData.total =  res.total;
        this.tableData = res.rows || [];
      })
      .catch(() => {
        this.pageData.total = 0;
        this.tableData = [];
      })
    },
    // 上传
    manualUploadChange(file, fileList, scope) {
      const size = Number(file.size / 1024 / 1024)
      if (size > 1) {
        this.$message.warning('无法上传超过1MB的文件，请联系管理员')
        fileList.splice(fileList.length - 1, 1);
        this.manualUploadBtnDisabled = fileList.length == 0
        return;
      }
      this.manualUploadBtnDisabled = fileList.length == 0
    },
    manualUploadBeforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    manualUploadRemove(file, fileList) {
      this.fileList = fileList;
      this.manualUploadBtnDisabled = fileList.length == 0
    },
    upLoadMethod(file) {
      console.log(file);
      this.fileData = new FormData();
      const isLt1M = this.fileList.every(
        (file) => file.size / 1024 / 1024 < 1
      );
      if (!isLt1M) {
        this.$message.error("请检查，上传文件大小不能超过1M");
      } else {
        this.fileData.append("file", file.file);
        this.progressPercent = 0;
        const uploadEvent = (progressEvent) => {
          this.progressPercent = Number(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
          );
        };
        // 接口上传
        manualUploadData(this.fileData, uploadEvent)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("上传成功");
            this.importStatus = "success";
          } else {
            this.importStatus = "exception";
            this.$message.error("导入失败，请检查文件是否正确");
          }
        })
        .catch( () => {
          this.importStatus = "exception";
          // this.$message.error("导入失败，请检查文件是否正确");
        })
        .finally(() => {
          this.progress = false;
          this.open = false
          this.resetQuery()
          this.$refs.manualUpload.clearFiles();
          this.fileData = "";
          this.fileList = [];
        })
      }
    },
    submitUpload() {
      this.progress = true;
      this.$refs.manualUpload.submit();
    },
    // 重新上传
    handleReloadManualUpload(rowData) {
      let params = {
        id:rowData.id
      }
      reloadManualUploadReq(params)
      .then(res => {
        this.getList()
      })
      .catch(err => {
        
      })
    }
  },
  created() {
    this.getList();
  },
}
</script>

<style scoped lang="scss">

</style>